import { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  const openNotifications = useCallback(() => {
    setIsNotificationOpen(true);
  }, []);

  const closeNotifications = useCallback(() => {
    setIsNotificationOpen(false);
  }, []);

  const toggleNotifications = useCallback(() => {
    setIsNotificationOpen(prev => !prev);
  }, []);

  return (
    <NotificationContext.Provider value={{
      isNotificationOpen,
      openNotifications,
      closeNotifications,
      toggleNotifications
    }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
